var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlogo01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "82.12px",
    height: "88.36px",
    viewBox: "0 0 82.12 88.36",
    enableBackground: "new 0 0 82.12 88.36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.48,0c4.38,0,8.48,1.26,12.31,3.79c3.83,2.53,6.92,5.93,9.28,10.23c2.35,4.29,3.53,9.09,3.53,14.39 c0,5.22-1.18,9.98-3.53,14.26c-2.35,4.29-5.44,7.73-9.28,10.29c-3.83,2.57-7.93,3.85-12.31,3.85H13.25l1.26-2.27v26.13 c0,2.19-0.68,4.02-2.02,5.49s-3.11,2.21-5.3,2.21c-2.11,0-3.83-0.73-5.18-2.21S0,82.85,0,80.67V7.7c0-2.19,0.73-4.02,2.21-5.49 C3.68,0.73,5.51,0,7.69,0H36.48z M36.48,42.41c1.59,0,3.15-0.67,4.66-2.02c1.52-1.35,2.78-3.09,3.79-5.24s1.52-4.4,1.52-6.75 c0-2.44-0.51-4.71-1.52-6.82c-1.01-2.1-2.27-3.81-3.79-5.11c-1.51-1.3-3.07-1.96-4.66-1.96H13l1.52-2.27v32.19l-1.39-2.02H36.48z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#00D0FF",
    cx: 74.12,
    cy: 79.32,
    r: 8.01
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlogo01);
export default __webpack_public_path__ + "static/media/plogo-01.9c6a6b7477cce8fa3bbcadea80afe1f8.svg";
export { ForwardRef as ReactComponent };